export const DATETIME_FORMAT = "YYYY-MM-DD HH:mm:ss";
export const DATE_FORMAT = "YYYY-MM-DD";
export const DATE_YEAR_MONTH_FORMAT = "YYYY-MM";

// Use this format to send data to Laravel. Laravel will convert to UTC properly
export const DATETIME_TZ_FORMAT = "YYYY-MM-DDTHH:mm:ssZZ";
